import { render, staticRenderFns } from "./reportsMain.vue?vue&type=template&id=3258b2e8&scoped=true&"
import script from "./reportsMain.vue?vue&type=script&lang=js&"
export * from "./reportsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3258b2e8",
  null
  
)

export default component.exports